/**
 * 機能フラグ判定用のユーティリティ関数
 * 環境変数から機能の有効/無効を判定する
 */

/**
 * 環境変数から機能フラグの値を取得し、有効かどうかを判定する
 * @param key - 環境変数のキー（例: 'VITE_SHOW_MATCHING_FLOWS'）
 * @returns 環境変数の値が 'true' の場合に true を返す
 */
export const isFeatureEnabled = (key: keyof ImportMetaEnv): boolean => {
  const value = import.meta.env[key];
  if (value == null) {
    return true;
  }
  return value === "true";
};
